/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const Badge = (props: any) => (
<svg {...props} width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 72.667L1.075e-07 74.2041C1.87408e-07 75.3466 0.488592 76.4346 1.34255 77.1937L3 78.667L3 72.667L0 72.667Z" fill=""/>
<path d="M0 72.667L1.075e-07 74.2041C1.87408e-07 75.3466 0.488592 76.4346 1.34255 77.1937L3 78.667L3 72.667L0 72.667Z" fill="black" fillOpacity="0.5"/>
<mask id="mask0_5833_22657" style={{"maskType":"alpha"}} maskUnits="userSpaceOnUse" x="0" y="72" width="3" height="7">
<path d="M0 72.667L1.075e-07 74.2041C1.87408e-07 75.3466 0.488592 76.4346 1.34255 77.1937L3 78.667L3 72.667L0 72.667Z" fill=""/>
<path d="M0 72.667L1.075e-07 74.2041C1.87408e-07 75.3466 0.488592 76.4346 1.34255 77.1937L3 78.667L3 72.667L0 72.667Z" fill="black" fillOpacity="0.5"/>
</mask>
<g mask="url(#mask0_5833_22657)">
<path d="M0 71.667L2.33127e-07 76.0003L3 73.0003L3 71.667L0 71.667Z" fill=""/>
</g>
<path d="M72 0H74.2031C75.3456 0 76.4337 0.488591 77.1927 1.34254L78.666 3H72V0Z" fill=""/>
<path d="M72 0H74.2031C75.3456 0 76.4337 0.488591 77.1927 1.34254L78.666 3H72V0Z" fill="black" fillOpacity="0.5"/>
<mask id="mask1_5833_22657" style={{"maskType":"alpha"}} maskUnits="userSpaceOnUse" x="72" y="0" width="7" height="3">
<path d="M72 0H74.2031C75.3456 0 76.4337 0.488591 77.1927 1.34254L78.666 3H72V0Z" fill=""/>
<path d="M72 0H74.2031C75.3456 0 76.4337 0.488591 77.1927 1.34254L78.666 3H72V0Z" fill="black" fillOpacity="0.5"/>
</mask>
<g mask="url(#mask1_5833_22657)">
<path d="M72 0H75.9993L73 3H72V0Z" fill=""/>
</g>
<path d="M73.5858 0H47.4649C45.8736 0 44.3475 0.632143 43.2222 1.75736L1.75736 43.2222C0.632141 44.3475 0 45.8736 0 47.4649V73.5858C0 74.4767 1.07714 74.9229 1.70711 74.2929L74.2929 1.70711C74.9229 1.07714 74.4767 0 73.5858 0Z" fill=""/>
</svg>
);

export default Badge;